<template>
    <div class="row">
        <div class="col-12 mb-3">
            <router-link class="btn text-white btn-dark active item tab-styling" to="/settings/create/eventtype">Maak een eventtype aan</router-link>
        </div>
        <div class="col-12 evnt-div-wrap">
            <table class="table table-responsive evnt-tb-wrap">
                <thead>
                    <tr>
                        <th></th>
                        <th>Titel</th>
                        <th>Commissies</th>
                        <th>Groepen</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(eventtype,index) in eventtypes" :key="index">
                        <td>
                            <router-link :to="'/settings/edit/eventtype/'+eventtype.id" class="btn btn-primary mr-2"><i class="fas fa-edit"></i></router-link>
                            <button @click="deleteEventType(eventtype.id)" class="btn btn-danger"><i class="fas fa-trash"></i></button>
                        </td>
                        <td>{{eventtype.title}}</td>
                        <td>{{eventtype.committees.length}}</td>
                        <td>{{eventtype.groups.length}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            eventtypes :[]
        }
    },
    methods:{
        deleteEventType(id){
            if(!window.confirm("Are you sure you want delete this item?")){
                return false;
            }

            this.$store.dispatch('delete','api/v1/eventtypes/'+id)
            .then((data)=>{
                console.log(data);
                window.location.reload();
            })
            .catch((error)=>{
                console.log(error.request);
            })
        }
    },
    created(){
        this.$store.dispatch('get','api/v1/eventtypes')
        .then((data)=>{
            console.log(data);
            this.eventtypes = data.data.data;
        })
        .catch((error)=>{
            if(error.request.status == 422){
                var response=JSON.parse(error.request.response).errors;
                for(var err in response){
                    this.error=response[err][0];
                }
            }
        });
    }
}
</script>